import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import 'dayjs/locale/en';
import utc from 'dayjs/plugin/utc';

import { dayjsFormat } from '@/constants/dayjs';

type DayjsFormat = keyof typeof dayjsFormat;

dayjs.extend(utc);

export const getUTCDate = (time = '', format?: DayjsFormat) => {
  if (!time && format) {
    return dayjs.utc().format(dayjsFormat[format]);
  }

  if (!time) {
    return dayjs.utc().format(dayjsFormat.default);
  }

  if (!dayjs(time).isValid()) {
    return undefined;
  }

  if (!format) {
    return dayjs.utc(time).format(dayjsFormat.default);
  }

  if (format === 'yearMonthDayDayOfTheWeek') {
    dayjs.locale('ko');
    return dayjs.utc(time).format(dayjsFormat.yearMonthDayDayOfTheWeek);
  }

  dayjs.locale('en');
  return dayjs.utc(time).format(dayjsFormat[format]);
};
